namespace Matrix.Indexation {
    export interface IndexPriceRow {
        IndexationProfileCode?: string;
        IndexCode?: string;
        PriceTypeCode?: string;
        PriceDate?: string;
        IndexPrice?: number;
        SourceCode?: string;
        IndexPriceCurrency?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        IndexationProfileName?: string;
        IndexationProfileIndexationInstanceId?: string;
        IndexationProfileEffectiveDate?: string;
        IndexationProfileValidFrom?: string;
        IndexationProfileValidTo?: string;
        IndexationProfileShortName?: string;
        IndexationProfileRowId?: number;
        IndexationProfileDefaultSortOrder?: number;
        IndexName?: string;
        IndexLocalCurrencyCode?: string;
        IndexTypeCode?: string;
        IndexPriceSource1?: string;
        IndexPriceSource1Id?: string;
        IndexPriceSource2?: string;
        IndexPriceSource2Id?: string;
        IndexFxOtherCurrency?: string;
        IndexRowId?: number;
        IndexDefaultSortOrder?: number;
        PriceTypeName?: string;
        PriceTypeRowId?: number;
        PriceTypeDefaultSortOrder?: number;
        SourceName?: string;
        SourceGroup?: string;
        SourceCategory?: string;
        SourceId?: number;
        SourceRowId?: number;
        IndexPriceCurrencyName?: string;
        IndexPriceCurrencyRowId?: number;
        IndexPriceCurrencyDefaultSortOrder?: number;
    }

    export namespace IndexPriceRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'Indexation.IndexPrice';
        export const deletePermission = 'DataAdmin:IndexPrice';
        export const insertPermission = 'DataAdmin:IndexPrice';
        export const readPermission = 'Read:IndexPrice';
        export const updatePermission = 'DataAdmin:IndexPrice';

        export declare const enum Fields {
            IndexationProfileCode = "IndexationProfileCode",
            IndexCode = "IndexCode",
            PriceTypeCode = "PriceTypeCode",
            PriceDate = "PriceDate",
            IndexPrice = "IndexPrice",
            SourceCode = "SourceCode",
            IndexPriceCurrency = "IndexPriceCurrency",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            IndexationProfileName = "IndexationProfileName",
            IndexationProfileIndexationInstanceId = "IndexationProfileIndexationInstanceId",
            IndexationProfileEffectiveDate = "IndexationProfileEffectiveDate",
            IndexationProfileValidFrom = "IndexationProfileValidFrom",
            IndexationProfileValidTo = "IndexationProfileValidTo",
            IndexationProfileShortName = "IndexationProfileShortName",
            IndexationProfileRowId = "IndexationProfileRowId",
            IndexationProfileDefaultSortOrder = "IndexationProfileDefaultSortOrder",
            IndexName = "IndexName",
            IndexLocalCurrencyCode = "IndexLocalCurrencyCode",
            IndexTypeCode = "IndexTypeCode",
            IndexPriceSource1 = "IndexPriceSource1",
            IndexPriceSource1Id = "IndexPriceSource1Id",
            IndexPriceSource2 = "IndexPriceSource2",
            IndexPriceSource2Id = "IndexPriceSource2Id",
            IndexFxOtherCurrency = "IndexFxOtherCurrency",
            IndexRowId = "IndexRowId",
            IndexDefaultSortOrder = "IndexDefaultSortOrder",
            PriceTypeName = "PriceTypeName",
            PriceTypeRowId = "PriceTypeRowId",
            PriceTypeDefaultSortOrder = "PriceTypeDefaultSortOrder",
            SourceName = "SourceName",
            SourceGroup = "SourceGroup",
            SourceCategory = "SourceCategory",
            SourceId = "SourceId",
            SourceRowId = "SourceRowId",
            IndexPriceCurrencyName = "IndexPriceCurrencyName",
            IndexPriceCurrencyRowId = "IndexPriceCurrencyRowId",
            IndexPriceCurrencyDefaultSortOrder = "IndexPriceCurrencyDefaultSortOrder"
        }
    }
}
